import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationCreatorServicePurchase.vue";

export const selector = (item: Notification): boolean => {
  return (
    item.type === NotificationType.CREATOR_SERVICE_PURCHASED_CONSUMER ||
    item.type === NotificationType.CREATOR_SERVICE_PURCHASED_PROVIDER
  );
};
